import { Modal } from 'component/Modal/Modal'
import { Typo } from 'component/Typo/Typo'
import { Vertical } from 'component/Vertical/Vertical'
import { useEffect, useState } from 'react'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'

interface GenerationModalProps {
  open: boolean
  onClose: () => void
}

export const GenerationModal = ({ open, onClose }: GenerationModalProps) => {
  const [timeLeft, setTimeLeft] = useState(3)

  useEffect(() => {
    if (!open) return

    setTimeLeft(3)
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          onClose()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [open, onClose])

  return (
    <Modal open={open} onCancel={onClose} width={400}>
      <Vertical gap={18} center pad={24}>
        <Icon success size={24} name="check_circle" />
        <Vertical gap={16} center>
          <Typo size={16} weight={600} center>
            {i18n('combo.GenerationModalTitle')}
          </Typo>
          <Typo size={14} secondary center>
            {i18n('combo.GenerationModalText')}
          </Typo>
        </Vertical>

        <Typo size={12} tertiary center>
          {i18n('combo.GenerationModalTimer', {
            time: timeLeft.toString().padStart(2, '0'),
          })}
        </Typo>
      </Vertical>
    </Modal>
  )
}
